export enum CallTypes {
  creating = 1,
  getting = 2,
  updating = 3,
  deleting = 4,
}
